import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="relative bg-zinc-950 border-t border-white/5">
      {/* Subtle gradient accent line at top */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          
          {/* Logo Column */}
          <div className="lg:col-span-4 flex flex-col items-center lg:items-start">
            <img
              src="/logoCompleto.svg"
              alt="Seminario Misionero Arquidiocesano Redemptoris Mater de Medellín"
              className="h-28 w-auto mb-8 opacity-90"
              width="300"
              height="112"
              loading="lazy"
            />
            <div className="hidden lg:block w-12 h-px bg-white/20" />
          </div>

          {/* About Column */}
          <div className="lg:col-span-5">
            <h3 className="font-neocat text-sm tracking-[0.3em] font-semibold text-white mb-6">
              {t("footer.about_title")}
            </h3>
            <p className="text-zinc-400 text-sm leading-relaxed font-light">
              {t("footer.about_text")}
            </p>
          </div>

          {/* Contact Column */}
          <div className="lg:col-span-3">
            <h3 className="font-neocat text-sm tracking-[0.3em] font-semibold text-white mb-6 uppercase">
              {t("footer.contact_title")}
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 group">
                <MapPin size={16} className="text-zinc-500 mt-0.5 flex-shrink-0 group-hover:text-white transition-colors duration-300" />
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=6.2254673,-75.5348959"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-zinc-400 text-sm font-light leading-relaxed hover:text-white transition-colors duration-300"
                >
                  Calle 48 No. 4-131<br />
                  Medellín, Antioquia
                </a>
              </li>
              <li className="flex items-center gap-3 group">
                <Phone size={16} className="text-zinc-500 flex-shrink-0 group-hover:text-white transition-colors duration-300" />
                <div className="text-zinc-400 text-sm font-light">
                  <span>PBX: [604] 444 56 21</span>
                  <br />
                  <span>Cel: 321 775 7120</span>
                </div>
              </li>
              <li className="flex items-center gap-3 group">
                <Mail size={16} className="text-zinc-500 flex-shrink-0 group-hover:text-white transition-colors duration-300" />
                <a
                  href="mailto:bienhechores@srmmedellin.org"
                  className="text-zinc-400 text-sm font-light hover:text-white transition-colors duration-300"
                >
                  bienhechores@srmmedellin.org
                </a>
              </li>
            </ul>
            <div className="mt-6">
              <p className="text-zinc-500 text-xs font-light">Nit: 800088662-6</p>
              <a
                href="http://www.srmmedellin.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-zinc-400 text-xs font-light hover:text-white transition-colors duration-300"
              >
                srmmedellin.org
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/5 py-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-4">
            <p className="text-zinc-600 text-xs font-light tracking-wider">
              © 2026 SRM-Medellín
            </p>
            <span className="text-zinc-800">|</span>
            <Link to="/noticias" className="text-zinc-600 text-xs font-light hover:text-white transition-colors">
              {t("navbar.news")}
            </Link>
            <span className="text-zinc-800">|</span>
            <Link to="/politica-de-privacidad" className="text-zinc-600 text-xs font-light hover:text-white transition-colors">
              {t("footer.privacy_policy")}
            </Link>
          </div>
          <div className="flex items-center gap-1 text-zinc-700 text-[10px] tracking-wider uppercase">
            <span>Ad Maiorem Dei Gloriam</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
